export enum LessonEvent {
  ACTIVITY_COMPLETED = 'ACTIVITY_COMPLETED',
  LESSON_COMPLETED = 'LESSON_COMPLETED',
  CONTINUE_PRESSED = 'CONTINUE_PRESSED',
  LESSON_RATED = 'LESSON_RATED',
  PLAYER_CLOSED = 'PLAYER_CLOSED',
  CUSTOM_GA_EVENT = 'CUSTOM_GA_EVENT',
}
